import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import "./AllEquitiesWelcome.css";
function AllEquitiesWelcome() {
  return (
    <>
      <section className="all-equities-welcome">
        <Container>
          <Row>
            <Col md={12}>
              <h1>All Equities</h1>
             
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default AllEquitiesWelcome;
